<template>
  <div class="main">
    <RadioGroup class="subRadio" :options="subRadioData" @radioChange="subRadioChange" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField>

    <div class="infos">
      <div class="item" v-for="(n, i) in infos" :key="'info' + i">
        <div class="label">{{ n.label }}</div>
        <div class="value">{{ n.value }}</div>
      </div>
    </div>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'fuelsale',
      getListUrl: 'reccar',
      subRadioData: [
        { label: "全部", value: 0 },
        { label: "本月", value: 1 },
        { label: "今天", value: 2 },
        { label: "昨天", value: 3 },
        { label: "前天", value: 4 },
      ],
      formInline: { daytime: 0 },
      formCtrl: [
        {
          ...this.ctrls.date,
          label: '订单时间：',
        },
        {
          ...this.ctrls.license,
        },
      ],
      infos: [
        { label: '金额合计：', value: '10568元' },
        { label: '油量合计：', value: '1645.35升' },
      ],
      cols: [
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "total", label: "金额", align:'right', className:'pr30' },
        { prop: "totalfuel", label: "加油量/升", align:'right', className:'pr30' },
      ],
      btns: [
        {
          icon: "el-icon-s-order",
          title: "查看销售列表",
          cb: ({ license }) => {
            // console.log(license)
            this.$router.push(
              `/oilStation/fuelSalesList?license=${license}`
            );
          },
        },
      ],
    };
  },
  methods: {
    subRadioChange(v) {
      // console.log(v);
      this.formInline.daytime = v
      this.getList();
    },
    tableDataHandler({ count, data, total, totalfuel }) {
      this.total = count
      if (data && data.length) {
        this.tableData = [...data]
      }
      this.infos[0].value = total + '元'
      this.infos[1].value = totalfuel + '升'
    },
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.main {
  .subRadio {
    text-align: left;
    background: #fff;
    margin: 0;
    padding: 20px;
    border-bottom: 3px solid #F2F6FC;

    /deep/ .el-radio-group {
      .el-radio-button {
        margin-right: 10px;

        .el-radio-button__inner {
          border: none;
          border-radius: 20px;
          padding: 8px 12px;
        }
      }
    }
  }

  .infos {
    background: #fff;
    display: flex;
    padding: 0 25px 25px;

    .item {
      display: flex;
      width: 200px;
      font-size: 14px;

      .label {
        color: #C0C4CC;
      }
    }
  }
}
</style>
